import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import type {
  LockProModeMutation,
  LockProModeMutationVariables,
} from './__generated__/useLockProMode.graphql.ts';
import { useMutation } from './graphql/useMutation.ts';

const LOCK_PRO_MODE_MUTATION = gql`
  mutation LockProModeMutation($input: lockProModeInput!, $sport: Sport!) {
    lockProMode(input: $input) {
      currentUser {
        slug
        anyUserSportProfile(sport: $sport) {
          id
          proUnlocked
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<LockProModeMutation, LockProModeMutationVariables>;

export const useLockProMode = () => {
  const { currentUser } = useCurrentUserContext();
  const [lockProMode, { loading }] = useMutation(LOCK_PRO_MODE_MUTATION, {
    showErrorsWithSnackNotification: true,
    optimisticResponse: {
      lockProMode: {
        __typename: 'lockProModePayload',
        currentUser: {
          __typename: 'CurrentUser',
          slug: currentUser?.slug || '',
          anyUserSportProfile: {
            __typename: 'FootballUserSportProfile',
            id: currentUser?.anyUserSportProfile?.id || '',
            proUnlocked: false,
          },
        },
        errors: [],
      },
    },
  });

  return { lockProMode, loading };
};
